<template>
  <div class="voice-commands">
    <div v-for="(command, i) in $props.commands" :key="i" class="voice-command">
      <font-awesome-icon
        style="padding-right: 4px;"
        :icon="['fas', 'microphone']"
      />
      <div>"{{ command }}"</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoiceCommands",
  props: {
    commands: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.voice-command {
  display: flex;
  margin: 30px 0;
  align-items: center;
  svg {
    color: $color-gray;
    font-size: 22px;
    margin-right: 20px;
  }
}
</style>
